import { FieldStatus } from 'generated/graphql';

import { IStatusable } from 'helpers';

import { BaseAddr } from './types/BaseAddr';

/**
 * Extract either the verified address or all valid addresses
 * if no address is verified.
 *
 * @param entity
 */
export function extractAllUnlessConfirmedAddresses<
  TAddressType extends BaseAddr & IStatusable
>(
  addresses: TAddressType[]
) {
  const nonBadAddresses =
    addresses
      .filter(a => a.status !== FieldStatus.Bad && a.status !== FieldStatus.DoNotContact);

  const confirmedAddresses =
    addresses
      .filter(a => a.status === FieldStatus.Verified);

  const addressToMakePointsFor = confirmedAddresses.length > 0 ? confirmedAddresses : nonBadAddresses;

  return addressToMakePointsFor;
}
